import { IataAirline } from "../../iata/objects/iataAirline";
import { IataCity } from "../../iata/objects/iataCity";
import { IataCountry } from "../../iata/objects/iataCountry";
import { RateErrors } from "./marginFlightForm";
import { Rate } from "./rate";

export enum MarginFlightTariffType { PRIVATE = 'PRIVATE', PUBLIC = 'PUBLIC', MIXED = 'MIXED' }
export enum MarginFlightSource { STANDARD = 'STANDARD', NDC = 'NDC' }
export enum MarginFlightCabin { ECONOMY = 'ECONOMY', PREMIUM = 'PREMIUM', BUSINNESS = 'BUSINESS', FIRST = 'FIRST' }
export enum MarginFlightSpecific {
    EMPTY_CHOICE = 'generic_margin',
    FLIGHT_CLASS_BOOKING = 'flight_class_booking',
    FLIGHT_FARE_BASIS = 'flight_fare_basis',
    EXTRA_TYPE = 'extra_type',
    IATA_AIRLINE = 'iata_airline',
    IATA_CITY = 'iata_city',
    IATA_COUNTRY = 'iata_country',
    FLIGHT_TARIFF_TYPE = 'flight_tariff_type',
    FLIGHT_SOURCE = 'flight_source',
    FLIGHT_CABIN = 'flight_cabin',
    IS_INFANT = 'is_infant',
    FLIGHT_IS_TAX = 'flight_is_tax',
    FLIGHT_IS_FEE_TAX = 'flight_is_fee_tax',
}

export interface FlightSpecificLevel {
    flight_specific: MarginFlightSpecific;

    flight_class_booking: string[];
    flight_fare_basis: string[];
    extra_type?: 'BAGGAGE' | 'SEAT';
    iata_airline: IataAirline[];
    iata_city: IataCity[];
    iata_country: IataCountry[];

    flight_tariff_type: MarginFlightTariffType[];
    flight_source: MarginFlightSource[];
    flight_cabin: MarginFlightCabin[];

    is_infant: boolean;
    flight_is_tax: boolean;
    flight_is_fee_tax: boolean;

    rate?: Rate & RateErrors;

}


export const EMPTY_FLIGHT_SPECIFIC_LEVEL: FlightSpecificLevel = {
    flight_specific: MarginFlightSpecific.EMPTY_CHOICE,
    flight_class_booking: [],
    flight_fare_basis: [],
    iata_airline: [],
    iata_city: [],
    iata_country: [],
    flight_tariff_type: [],
    flight_source: [],
    flight_cabin: [],
    extra_type: 'BAGGAGE',
    is_infant: true,
    flight_is_tax: true,
    flight_is_fee_tax: true
};
